<template>
  <f7-page
    :theme-dark="dark"
    id="settings-map">

    <f7-navbar
      back-link
      :theme-dark="dark"
      :title="t('settingsMapTitle')">
    </f7-navbar>

    <f7-block>
      <f7-row
        v-for="(c, i) in groupStiles"
        :key="i">
        <f7-col
          v-for="style in c"
          :key="style">
          <div
            class="selector-tiles"
            @click="select(style)"
            :class="{ 'selected' : selected(style) }">
            <div class="selector-tiles-img">
              <img :src="'/img/map/' + style + '.png'">
              <FlatIcon
                v-if="selected(style)"
                name="tick"
                :size="32"
                class="selector-tiles-icon" />
            </div>
            <span class="selector-tiles-label">
              {{ t('tiles' + style) }}
            </span>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>

  </f7-page>
</template>

<script>
import chunk from 'lodash/chunk'
import { mapGetters, mapActions } from 'vuex'
import { styles } from '@/services/maptiler'
export default {
  name: 'SettingsMap',
  data () {
    return {
      styles
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    groupStiles () {
      return chunk(this.styles, 3)
    }
  },
  methods: {
    ...mapActions({
      setSetting: 'global/setSetting'
    }),
    selected (style) {
      return this.setting('tiles') === style
    },
    select (tiles) {
      this.setSetting({ tiles })
      this.$f7router.navigate('/')
    }
  }
}
</script>

<style lang="scss">
.selector-tiles {
  text-align: center;
  margin-bottom: var(--f7-block-padding-horizontal);
  .selector-tiles-img {
    display: block;
    position: relative;
    background: var(--f7-list-bg-color);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
    padding: 10px;
    line-height: 0;
    border-radius: 10px;
    img {
      width: 100%;
      height: auto;
      transition: opacity 0.2s ease-in-out;
      border-radius: 6px;
    }
  }
  .selector-tiles-label {
    display: inline-block;
    white-space: nowrap;
    padding: 2px 8px;
    margin-top: 10px;
    border-radius: 20px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .selector-tiles-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.selected {
    .selector-tiles-img {
      img {
        opacity: 0.4;
      }
    }
    .selector-tiles-label {
      background: var(--f7-theme-color);
      color: white;
    }
  }
}
</style>

<docs>
```js
<SettingsMap />
```
</docs>
